var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "preact/jsx-runtime";
import { useEffect, useRef, useState } from "preact/hooks";
const LightboxYouTubePlayer = ({ url }) => {
    const iFrameRef = useRef(null);
    const playerRef = useRef(null);
    const [normalizedUrl, setNormalizedUrl] = useState("");
    const [aspectRatio, setAspectRatio] = useState("16/9");
    const extractYouTubeUrl = (url) => {
        // Support various YouTube URL formats
        const patterns = [
            /(?:https?:\/\/)?(?:www\.)?youtube\.com\/watch\?v=([a-zA-Z0-9_-]+)/,
            /(?:https?:\/\/)?(?:www\.)?youtu\.be\/([a-zA-Z0-9_-]+)/,
            /(?:https?:\/\/)?(?:www\.)?youtube\.com\/embed\/([a-zA-Z0-9_-]+)/,
        ];
        for (const pattern of patterns) {
            const match = url.match(pattern);
            if (match) {
                const videoId = match[1];
                return `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`;
            }
        }
        return null;
    };
    const fetchYouTubeVideoData = (videoId) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const response = yield fetch(`https://www.googleapis.com/youtube/v3/videos?id=${videoId}&part=snippet`);
            const data = yield response.json();
            if (data.items && data.items.length > 0) {
                const { width, height } = data.items[0].snippet.thumbnails.maxres ||
                    data.items[0].snippet.thumbnails.standard ||
                    data.items[0].snippet.thumbnails.medium;
                if (width && height) {
                    setAspectRatio(`${width}/${height}`);
                }
            }
        }
        catch (error) {
            console.error("Error fetching YouTube video data:", error);
        }
    });
    const onVideoPlay = () => {
        var _a;
        (_a = iFrameRef.current) === null || _a === void 0 ? void 0 : _a.classList.add("ready");
    };
    useEffect(() => {
        const normalizedUrl = extractYouTubeUrl(url);
        if (!normalizedUrl)
            return;
        setNormalizedUrl(normalizedUrl);
        // Extract video ID from URL for potential API call
        const videoIdMatch = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([a-zA-Z0-9_-]+)/);
        if (videoIdMatch) {
            // Optionally fetch video data for aspect ratio
            // fetchYouTubeVideoData(videoIdMatch[1]);
        }
    }, [url]);
    useEffect(() => {
        if (!iFrameRef.current || !normalizedUrl)
            return;
        // Create YouTube player instance
        playerRef.current = {
            play: () => onVideoPlay(),
            destroy: () => {
                playerRef.current = null;
            },
        };
        onVideoPlay();
        return () => {
            if (playerRef.current) {
                playerRef.current.destroy();
            }
        };
    }, [normalizedUrl]);
    return (_jsx("iframe", { ref: iFrameRef, allow: "autoplay; encrypted-media; fullscreen", allowFullScreen: true, src: normalizedUrl, style: {
            aspectRatio: aspectRatio,
            width: "100%",
            height: "auto",
        } }));
};
export default LightboxYouTubePlayer;
